import { FeatureFlagName } from 'lib-shared-feature-flags';
import { useMemo } from 'react';

import { useAppSelector } from 'utils/redux/useAppSelector';

import { FeatureFlagResult, featureFlags } from '../featureFlags';

/**
 * A hook that evaluates a set of feature flags.
 *
 * This handles memorization and is the preferred way to consume feature flags
 * in function components as opposed to using the `featureFlags.get` method.
 */
export const useFeatureFlag = <TFeatureFlagName extends FeatureFlagName>(
  names: readonly TFeatureFlagName[],
): FeatureFlagResult<TFeatureFlagName> => {
  const asyncStatus = useAppSelector(
    (state) => state.app.asyncStatus.featureFlags,
  );

  // The result of the feature flags.
  const result = useMemo(
    () => featureFlags.get(names),
    // We want to recompute the result whenever the async status changes
    // regardless of its value.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [names, asyncStatus],
  );

  return result;
};
